import React from "react";
import { IconProps } from "../icon";

export const CurrencyYenIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 20.5v-9m0 0l6.5-8m-6.5 8l-6.5-8m12.5 8H6m11 4H7"
    />
  </svg>
);
